/* Costack quick-add card picker
 * 15 Sep 2026: THE CARDS NEVER RENDERED. The click hook required
 * .quick-add__submit[data-product-url], and Dawn 16 stopped putting that attribute
 * on the button, so the selector never matched, the poller never started, and the
 * Choose options modal fell back to the bare Pack dropdown on every collection and
 * search page. Caught on a phone recording, reproduced on the live theme.
 * It now watches the modals themselves, so it does not care how the modal opened.
 * Same date, second fault: picking a pack re-rendered the modal, the cards were
 * rebuilt from scratch and snapped straight back to Single Bottle, so the shopper
 * could never actually choose a multipack. The chosen pack is now remembered per
 * product and survives the rebuild, exactly as on the product page.
 * Also brought in line with the product page: sold-out packs are marked and never
 * badged MOST POPULAR or FREE UK delivery, the picker opens on the cheapest pack
 * that can actually be bought, and Single Bottle reads as stored (only the sachet
 * line reads Single sachet).
 */
(function () {
  'use strict';

  function money(p) { return '£' + (p / 100).toFixed(2); }

  var PACK_LABELS = { 'Single Pack': 'Single sachet', 'Single Sachet': 'Single sachet' };
  function packLabel(v) { return PACK_LABELS[v] || v; }

  var CSS = [
    '.cstk-qa-packs{display:flex;flex-direction:column;gap:8px;margin:8px 0 14px;}',
    '.cstk-qa-pk{display:flex;align-items:center;gap:10px;width:100%;text-align:left;border:1.5px solid #e0d5c2;background:#fff;border-radius:10px;padding:11px 13px;cursor:pointer;font-family:inherit;position:relative;}',
    '.cstk-qa-pk.is-sel{border-color:#b3641c;background:#fff8ef;}',
    '.cstk-qa-pk.is-out{opacity:.55;}',
    '.cstk-qa-pk__radio{flex:0 0 auto;width:18px;height:18px;border-radius:50%;border:2px solid #c9bda8;}',
    '.cstk-qa-pk.is-sel .cstk-qa-pk__radio{border-color:#b3641c;background:radial-gradient(#b3641c 42%,#fff 46%);}',
    '.cstk-qa-pk__main{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;}',
    '.cstk-qa-pk__name{font-size:14px;font-weight:600;color:#231900;}',
    '.cstk-qa-pk__badge{font-size:11px;font-weight:700;color:#1f7a37;}',
    '.cstk-qa-pk__out{font-size:11px;font-weight:700;color:#9a3412;}',
    '.cstk-qa-pk__pop{position:absolute;top:-9px;left:12px;background:#b3641c;color:#fff;font-size:10px;font-weight:700;padding:2px 8px;border-radius:6px;letter-spacing:.3px;}',
    '.cstk-qa-pk__right{flex:0 0 auto;text-align:right;display:flex;flex-direction:column;}',
    '.cstk-qa-pk__price{font-size:15px;font-weight:700;color:#231900;}',
    '.cstk-qa-pk__was{font-size:12px;color:#9a8e78;text-decoration:line-through;}',
    '.cstk-qa-pk__save{font-size:11px;font-weight:700;color:#b3641c;}'
  ].join('');

  function ensureCSS() {
    if (document.getElementById('cstk-qa-pack-css')) return;
    var st = document.createElement('style');
    st.id = 'cstk-qa-pack-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function handleFor(info) {
    var vs = info.querySelector('variant-selects, variant-radios');
    var url = (vs && (vs.getAttribute('data-url') || vs.dataset.url)) || '';
    if (!url) {
      var a = info.querySelector('a[href*="/products/"]');
      if (a) url = a.getAttribute('href') || '';
    }
    if (!url || url.indexOf('/products/') === -1) return null;
    return url.split('/products/')[1].split('/')[0].split('?')[0];
  }

  var busy = {};
  var chosen = {};
  var builds = {};

  function build(info) {
    if (!info || info.querySelector('.cstk-qa-packs')) return;
    var sel = info.querySelector('select[name="options[Pack]"]');
    if (!sel) return;
    var values = [].map.call(sel.options, function (o) { return o.value; });
    if (values.length < 2) return;
    var handle = handleFor(info);
    if (!handle) return;
    if (busy[handle]) return;
    builds[handle] = (builds[handle] || 0) + 1;
    if (builds[handle] > 25) return;
    busy[handle] = true;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        if (info.querySelector('.cstk-qa-packs')) { busy[handle] = false; return; }
        var byPack = {};
        prod.variants.forEach(function (v) { byPack[v.option1] = v; });
        ensureCSS();

        var wrap = document.createElement('div');
        wrap.className = 'cstk-qa-packs';
        var firstAvail = null;
        values.forEach(function (val) {
          var v = byPack[val]; if (!v) return;
          var live = !!v.available;
          if (!firstAvail && live) firstAvail = val;
          var price = v.price, was = v.compare_at_price;
          var save = (was && was > price) ? Math.round((1 - price / was) * 100) : 0;
          var free = live && price >= 3500;
          var pop = live && /5-?pack/i.test(val);
          var card = document.createElement('button');
          card.type = 'button';
          card.className = 'cstk-qa-pk' + (live ? '' : ' is-out');
          card.setAttribute('data-pack', val);
          card.innerHTML =
            (pop ? '<span class="cstk-qa-pk__pop">MOST POPULAR</span>' : '')
            + '<span class="cstk-qa-pk__radio" aria-hidden="true"></span>'
            + '<span class="cstk-qa-pk__main"><span class="cstk-qa-pk__name">' + packLabel(val) + '</span>'
            + (live ? (free ? '<span class="cstk-qa-pk__badge">FREE UK delivery</span>' : '') : '<span class="cstk-qa-pk__out">Sold out</span>') + '</span>'
            + '<span class="cstk-qa-pk__right"><span class="cstk-qa-pk__price">' + money(price) + '</span>'
            + (live && save ? '<span class="cstk-qa-pk__was">' + money(was) + '</span><span class="cstk-qa-pk__save">Save ' + save + '%</span>' : '') + '</span>';
          wrap.appendChild(card);
        });

        var box = sel.closest('.product-form__input') || sel.parentNode;
        box.style.display = 'none';
        box.parentNode.insertBefore(wrap, box);

        function selectPack(val) {
          chosen[handle] = val;
          if (sel.value !== val) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          [].forEach.call(wrap.querySelectorAll('[data-pack]'), function (el) { el.classList.toggle('is-sel', el.getAttribute('data-pack') === val); });
        }
        wrap.addEventListener('click', function (e) {
          var c = e.target.closest('[data-pack]'); if (!c) return;
          selectPack(c.getAttribute('data-pack'));
        });

        var want = (chosen[handle] && byPack[chosen[handle]]) ? chosen[handle] : (firstAvail || values[0]);
        selectPack(want);
        busy[handle] = false;
      })
      .catch(function () { busy[handle] = false; });
  }

  function sweep() {
    var infos = document.querySelectorAll('[id^="QuickAddInfo-"]');
    for (var i = 0; i < infos.length; i++) {
      var info = infos[i];
      if (!info.querySelector('.cstk-qa-packs')) build(info);
    }
  }

  var queued = false;
  function tick() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; sweep(); }, 80);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.quick-add__submit');
    if (!btn) return;
    var n = 0;
    var iv = setInterval(function () { n++; sweep(); if (n > 40) clearInterval(iv); }, 250);
  }, true);

  try { new MutationObserver(tick).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep);
  else sweep();
})();
